import {DomSanitizer} from "@angular/platform-browser";
import {Pipe} from "@angular/core";

@Pipe({name: 'safeIcon'})
export class SafeIconPipe {
  constructor(private sanitizer:DomSanitizer){}

  transform(icon) {
    return this.sanitizer.bypassSecurityTrustHtml("&#x"+icon+";");
  }
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/pipe/safe-icon.pipe.ts